var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":"Quản lý khách hàng"}}),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"total-rows":_vm.totalRows,"pagination-options":{
          enabled: true,
          rowsPerPageLabel: 'các mục trong trang',
          nextLabel: 'tiếp',
          prevLabel: 'trước',
          mode: 'records',
          perPage: _vm.perPage,
          perPageDropdown: [10, 20, 50],
          allLabel: 'Tất cả',
        },"line-numbers":true,"search-options":{ enabled: true },"mode":"remote"},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPerPageChange,"on-search":_vm.onSearch},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === '_id')?_c('span',[_c('DanhSachKhachNhan',{attrs:{"customer":props.row}})],1):_vm._e()]}}])})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }